export default __webpack_public_path__ + "static/media/cat-ban.285dbf6f.jpg";